import { motion } from "framer-motion"
import {ChevronDown} from 'lucide-react'

const HERO_IMAGE = "https://static.lumi.new/32/3259ae91b374289ea1fd6db1c6bbdadb.webp"

function Hero() {
  return (
    <section id="top" className="relative min-h-screen w-full overflow-hidden">
      <motion.img
        src={HERO_IMAGE}
        alt=""
        className="absolute inset-0 h-full w-full object-cover object-[50%_22%] md:object-[50%_18%]"
        initial={{ scale: 1.08 }}
        animate={{ scale: 1 }}
        transition={{ duration: 4.2, ease: [0.22, 1, 0.36, 1] }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-[#080808]" />
      <div className="absolute inset-0 bg-black/20" />

      <div className="relative z-10 flex min-h-screen w-full flex-col justify-end px-8 pb-24 pt-32 md:px-16 md:pb-20 lg:px-28">
        <motion.p
          className="font-sans-ui text-[11px] tracking-[0.48em] text-[#c4a574]"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, delay: 0.2 }}
        >
          01
        </motion.p>

        <motion.h1
          className="font-display mt-6 max-w-[18ch] whitespace-nowrap text-[9vw] leading-[0.92] tracking-[0.04em] text-[#f7f1e6] md:text-6xl lg:text-7xl"
          initial={{ opacity: 0, y: 28 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.4, delay: 0.4 }}
        >
          AROMA IDOL
        </motion.h1>

        <motion.p
          className="font-serif-tc mt-6 whitespace-nowrap text-base tracking-[0.22em] text-stone-200"
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, delay: 0.7 }}
        >
          邱鉦耀 Chill Jack Man
        </motion.p>

        <div className="mt-14 flex flex-col gap-10 md:mt-14 md:flex-row md:items-end md:justify-between">
          <motion.div
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.2, delay: 0.9 }}
          >
            <p className="font-sans-ui whitespace-nowrap text-xs tracking-[0.48em] text-stone-400">
              CHAMPION EDITION 001
            </p>
            <p className="font-serif-tc mt-2 whitespace-nowrap text-lg text-stone-100">
              冠軍限定香氛
            </p>
          </motion.div>

          <motion.p
            className="font-display max-w-md whitespace-nowrap text-lg italic leading-snug text-[#f4efe6] md:text-right md:text-3xl"
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.4, delay: 1.1 }}
          >
            一首歌、一個故事、一種味道
          </motion.p>
        </div>
      </div>

      <a
        href="#about"
        className="absolute bottom-6 left-1/2 z-10 flex -translate-x-1/2 flex-col items-center gap-2 text-stone-400 transition-colors duration-500 hover:text-[#c4a574]"
      >
        <span className="font-sans-ui text-[10px] tracking-[0.4em]">SCROLL</span>
        <ChevronDown className="h-4 w-4 animate-pulse" />
      </a>
    </section>
  )
}

export default Hero
